import React from 'react';
import { AdminBreadCrumbHeader } from '../admin-bread-crumb-header';
import { Content } from '../../shared/containers/content';
import { useOrganizationQuery } from '../../../api/queries/use-organization-query';
import { useCompanyId } from '../../../app/agistics-context';
import { Organization } from '../../../types';
import { EditCreateOrganization } from './edit-create-organization/edit-create-organization';
import { CircularLoading } from '../../shared/circular-loading';
import { Paper } from '@mui/material';

export const OrganizationSettings = () => {
    const companyId = useCompanyId();
    const organizationQuery = useOrganizationQuery<Organization>('', { orgId: companyId });

    return (
        <>
            <AdminBreadCrumbHeader />
            <Content>
                {organizationQuery.isSuccess ? (
                    <Paper sx={{ padding: '1rem' }}>
                        <EditCreateOrganization
                            existingOrganization={organizationQuery.data}
                        />
                    </Paper>
                ) : (
                    <CircularLoading />
                )}
            </Content>
        </>
    );
};
